import api from "../../../services/api";

const ACCOMPLISHMENT_URL = "/course/certificate";

export function getAccomplishment(certificate_code) {
  return api.get(`${ACCOMPLISHMENT_URL}/${certificate_code}`);
}
